import type { Theme } from '@/@types/theme';
import { themePixcasinoColors } from '@/themes/brandColors/pixcasino';

export const ThemePixcasino: Theme = {
  name: 'pixcasino',
  dark: true,
  colors: themePixcasinoColors,
};
